import { render, staticRenderFns } from "./shareManage.vue?vue&type=template&id=71e90258"
import script from "./shareManage.vue?vue&type=script&lang=js"
export * from "./shareManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports